import { useDispatch, useSelector } from "react-redux";
import { checkAssignTimeApi } from "../../api/agent/checkAssignTimeApi";
import { useEffect, useState } from "react";
import { checkStatus } from "#src/modules/reducers/chat/agent/checkAssignTime.js";
import { setMessage } from "#src/modules/reducers/chat/bot/qa.js";
import { useNavigate } from "react-router-dom";
import { initChatStatus } from "#src/modules/reducers/chat/agent/connectChatServer.js";

const useAssignTime = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const notAssignedTime = useSelector(
    (state) => state.checkAssignTime.notAssignedDuration
  );
  const [isAssigned, setIsAssigned] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [messageItem, setMessageItem] = useState(null);
  const getCurrentDayAndTime = () => {
    const now = new Date();
    const day = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const currentTimeInHours = hours + minutes / 60;

    return { day, currentTimeInHours };
  };

  const isWithinTimeRange = (hourFrom, hourTo, currentHour) => {
    if (hourFrom <= hourTo) {
      return currentHour >= hourFrom && currentHour < hourTo;
    } else {
      return currentHour >= hourFrom || currentHour < hourTo;
    }
  };

  const isCurrentTimeAvailable = (schedule) => {
    const { day, currentTimeInHours } = getCurrentDayAndTime();

    const todaySchedule = schedule.find((item) => item.day === day);
    if (!todaySchedule) return { available: true }; // 오늘 쉬는 스케줄이 없는 경우 true 반환

    for (const timeRange of todaySchedule.hours) {
      if (timeRange?.serviceErrorMessage) {
        return { available: false, message: timeRange?.serviceErrorMessage };
      }

      if (isWithinTimeRange(timeRange.from, timeRange.to, currentTimeInHours)) {
        return { available: false, message: timeRange.message }; // 현재 시간이 시간 쉬는 시간 범위에 포함되면 false 반환
      }
    }

    return { available: true }; // 현재 시간이 모든 시간 범위에 포함되지 않으면 true 반환
  };

  const handleClick = () => {
    setIsClicked(true);
    setIsAssigned(null);
    const api = checkAssignTimeApi();
    dispatch(checkStatus(api));
    dispatch(initChatStatus());
  };

  useEffect(() => {
    // 현재 시간이 스케줄에 해당되는지 확인
    const result = isCurrentTimeAvailable(notAssignedTime);
    if (result?.message) {
      try {
        const jsonObject = JSON.parse(result?.message);
        setMessageItem(jsonObject);
      } catch (error) {
        console.error('Failed to parse message:', error);
        setMessageItem(null);
      }
    }
    setIsAssigned(result.available);
  }, [notAssignedTime]);

  useEffect(() => {
    if (isClicked && isAssigned === true) {
      navigate("/chat?agree=true");
      setIsClicked(false);
    } else if (isClicked && isAssigned === false && messageItem) {
      dispatch(setMessage({ message: messageItem }));
      setIsClicked(false);
    }
  }, [isAssigned]);

  return { handleClick };
};

export default useAssignTime;
